import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Webhook, WebhookCreate, WebhookTestResponse, WebhookUpdate } from '../../../shared/interfaces/webhook.interfaces';

const basePath = '/dealer/webhook';

@Injectable({
  providedIn: 'root'
})

export class WebhookService {
  constructor(private http: HttpClient) { }

  // Gets all webhooks for the current dealer
  getWebhooks(): Observable<Webhook[]> {
    return this.http.get<Webhook[]>(basePath);
  }

  // Creates a new webhook for the current dealer
  createWebhook(payload: WebhookCreate): Observable<Webhook> {
    const body = {
      name: payload.name,
      url: payload.url
    }
    return this.http.post<any>(basePath, body);
  }

  // Updates an existing webhook
  updateWebhook(payload: WebhookUpdate): Observable<Webhook> {
    const body = {
      name: payload.name,
      url: payload.url
    }
    return this.http.put<Webhook>(`${basePath}/${payload.id}`, body);
  }

  // Deletes a specific webhook
  deleteWebhook(id: number) {
    return this.http.delete(`${basePath}/${id}`);
  }

  // Tests a specific webhook
  testWebhook(id: number): Observable<WebhookTestResponse> {
    const params = new HttpParams().set('id', id);
    return this.http.get<WebhookTestResponse>(`${basePath}/test`, { params });
  }

}
